import React, { useEffect } from 'react'
import { useState } from 'react'
import { Drawer, Form, Row, Col ,Button, Space, Flex, Typography, Image } from "antd"
import { MyDatepicker, MyInput, MySelect, SingleFileUpload } from '../../Forms';
import { CloseCircleOutlined } from '@ant-design/icons';
import { ActionButton } from '../../PageComponents';
import moment from 'moment';
import { apiCalls } from '../../../shared/Apis';


const { Title } = Typography
const AddJobDrawer = ({visible, onClose, edititem, getJobApi}) => {

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [ jobimage, setJobImage ] = useState(null)
    const [ servicelookup, setServiceLookup ] = useState([])

    useEffect(()=>{
        if (visible && edititem) {
            form.setFieldsValue({
                ...edititem,
                serviceID: edititem?.service?.name,
                image: edititem?.image,
                organizationName: edititem?.organizationName,
                budget: edititem?.budget,
                location: edititem?.location,
                date: moment(edititem?.date),
                description: edititem?.description,
            });
            getService()
            setJobImage(edititem?.image);
        } 
        else if(visible){
            getService();
        }else{
            form.resetFields()
            setJobImage(null);
        }

    },[visible, edititem])

    const updateCreateApi = async () => {
        setLoading(true);
        let data = form.getFieldsValue();
        let formData = new FormData();
        formData.append('image', data?.image);
        formData.append('organizationName', data?.organizationName);
        formData.append('budget', data?.budget);
        formData.append('location', data?.location);
        formData.append('date', data?.date);
        formData.append('description', data?.description);
        formData.append('id', edititem?.id);
        const serviceId = servicelookup.find(lookup => lookup.name == data.serviceID)?.id;
        formData.append('serviceID', serviceId);
        console.log('edit id',edititem?.id)
        try {
            const result = await apiCalls.addJobapi.updateCreateApi(formData, edititem?.id);
            setLoading(false);
            getJobApi();
            if (result) {
                form.resetFields();
                onClose();
            }
        } catch (error) {
            console.error('Error updating/creating job:', error);
            setLoading(false);
        }
    };
    
    const onFinish = async () => {
        try {
            const formData = await form.validateFields();
            updateCreateApi(formData);
        } catch (error) {
            console.error("Form validation error:", error);
        }
    };

    const closeDrawer = () => {
        form.resetFields(); 
        onClose();
    };

    const handleDeleteProfileImage = () => {
        setJobImage(null);
        form.setFieldsValue({ image: null });
    };

    const getService = async () => {
        let result= await apiCalls?.addJobapi?.getService()
        if(result)
        setServiceLookup(result)
    }

  return (
    <Drawer
        title={edititem?'Edit Job':'Add Job'}
        onClose={closeDrawer}
        className="drawer"
        open={visible}
        width={700}
        footer={
        <Space className="w-100 right">
            <Button 
                onClick={closeDrawer}
                className="btncancel"
            >
                Cancel
            </Button>
            <Button  
                block
                className='btnsave bg-brand'
                type="primary"
                htmlType="submit"
                loading={loading}
                onClick={()=> form.submit()}
            >
                {edititem? 'Update' : 'Save'}
            </Button>
        </Space>
    }
>
    <Form
        form={form}
        layout="vertical"
        initialValues={true}
        onFinish={onFinish}
        requiredMark={false}
    >
        <Row gutter={16} justify={'center'}>
            <Col span={24}>
                <Title level={5} className="mb-3 mt-0">JOB DETAILS</Title>
            </Col>
            <Col span={24}>
                <div className='my-3 width-drag'>
                    {
                        edititem && jobimage ? 
                        <div style={{ position: 'relative', width:100, margin: 'auto' }}>
                            <Flex justify='center'>
                                <Image
                                    src={jobimage}
                                    width={100}
                                    height={100}
                                    className='radius-12'
                                />
                            </Flex>
                            <div className='over-img'>
                                <ActionButton
                                    icon={<CloseCircleOutlined  className='text-inactive' />}
                                    onClick={handleDeleteProfileImage}
                                    type='ghost'
                                />
                            </div>
                        </div>
                        :
                        <SingleFileUpload 
                            name='image'
                            title='Upload Profile'
                            required
                            message='Please upload image'
                            form={form}
                            autoComplete='off'
                        />
                    }
                </div>
            </Col>
            <Col lg={{span: 24}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                <MySelect
                    label= 'Service'
                    name="serviceID" 
                    size={'large'}
                    required
                    message='Please choose service'
                    options={servicelookup}
                />
            </Col>
            <Col lg={{span: 12}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                <MyInput
                    label= 'Organization Name'
                    name="organizationName" 
                    size={'large'}
                    required
                    message='Please enter organization name'
                />
            </Col>
            <Col lg={{span: 12}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                <MyInput
                    label= 'Budget'
                    name="budget" 
                    size={'large'}
                    required
                    message='Please enter budget'
                />
            </Col>
            <Col lg={{span: 12}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                <MyInput
                    label= 'Location'
                    name="location" 
                    size={'large'}
                    required
                    message='Please enter location'
                />
            </Col>
            <Col lg={{span: 12}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                <MyDatepicker
                    datePicker
                    label= 'Date'
                    name="date" 
                    size={'large'}
                    required
                    message='Please enter date'
                />
            </Col>
            <Col span={24}>
                <MyInput
                    textArea
                    label= 'Description'
                    name="description" 
                    size={'large'}
                    required
                    message='Please enter description'
                    rows={6}
                />
            </Col>
        </Row>
    </Form>
</Drawer>
  )
}

export {AddJobDrawer}